<template>
  <div id="Certificate">
    <div class="btns" @click="showAlert_fn" v-if="isShowBtn">
      <img :src="activity?btnCertificateMy:btnCertificateGet" alt="">
    </div>
    <div class="certificateBox" v-if="isShowAlert">
      <div class="mask" @click="hideAlert_fn"></div>
      <div class="alertBox">
        <img class="alertBg" :src="certificate_alert" alt="">
        <div class="alertCon">
          <p class="msg1">您已满足学习时长</p>
          <p class="msg2">· 可领取课程证书 ·</p>
          <input v-model="name" type="text" placeholder="请输入姓名">
          <img @click="submit_fn" class="btn" :src="certificate_submit" alt="">
          <p class="msg3">姓名信息只能填写一次， 暂不支持修改</p>
        </div>
        <img class="close" @click="hideAlert_fn" :src="btnClose" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  import {getActivityInfo, saveActivityUser, exchangeGoods, getExchangeInfo} from "@/api";
  import {getUserId, downloadIamge} from "@/utils/methods.js";
  import {message, Modal} from "ant-design-vue";
  import Cookie from "js-cookie";

  export default {
    name: "Certificate",
    components: {Modal},
    computed: {
      // 播放器对象
      player_cpu() {
        return this.$store.state.player;
      }
    },
    data() {
      return {
        btnCertificateGet: require('@a/img/certificate_get.png'),
        btnCertificateMy: require('@a/img/certificate_my.png'),
        certificate_alert: require('@a/img/certificate_alert.png'),
        certificate_submit: require('@a/img/certificate_submit.png'),
        btnClose: require('@a/img/close.png'),
        isShowAlert: false, // 是否显示弹窗
        activity: false,  // 是否领取
        watchCredit: 0, // 所需分钟
        playerTime: 0,
        playerInterval: null, // 获取播放时间的循环函数
        name: '', // 姓名
        hasCertificate: false,
        ocs_muke_time: 0, // 播放时长
        lock_once: true,
        isShowBtn: false,
        goodsId: 0,// 礼物id
        customizationId: '1584', // 定制id
        activityId: 2, // 礼物id
        videoid: this.$route.query.courseId?this.$route.query.courseId:this.$route.params.videoId,
      }
    },
    methods: {
      // 获取pdf
      getExchangeInfo() {
        getExchangeInfo({
          goodsId: this.goodsId,
          userId: getUserId(true)
        }).then(res => {
          window.open(res.data.list[0].url);
          // downloadIamge(res_3.data.list[0].url,res_3.data.list[0].goodsName);
        })
      },

      // 显示弹框 是否领取
      showAlert_fn() {
        if (this.activity) {
          // 获取pdf
          this.getExchangeInfo();
        } else {
          this.isShowAlert = true;
          this.isShowBtn = true;
          document.body.style.overflow = 'hidden';
        }
        clearInterval(this.playerInterval);
        this.lock_once = false;
      },

      // 隐藏弹框
      hideAlert_fn() {
        this.isShowAlert = false;
        this.isShowBtn = true;
        document.body.style.overflow = 'auto';
      },

      // 立即领取
      submit_fn() {
        let that = this;
        Modal.confirm({
          title: '提示',
          content: '姓名信息只能填写一次， 暂不支持修改！',
          centered: true,
          okText: '确定',
          onCancel() {
          },
          onOk() {
            if (that.name) {
              if (!getUserId(true)) {
                return;
              }
              // 第一步：修改证书名字
              saveActivityUser({
                userId: getUserId(true),
                activityId: that.activityId,
                realName: that.name
              }).then(res => {
                // 第二步：兑换证书的请求
                exchangeGoods({
                  goodsId: that.goodsId,
                  userId: getUserId(true)
                }).then(res_2 => {
                  // 第三步：请求兑换的证书信息
                  that.getExchangeInfo();
                  that.hideAlert_fn();
                  that.activity = true;
                })
              })
            } else {
              message.error('请输入您的真实姓名！')
            }
          },
        });
      },

      // 获取活动详情
      getActivityInfo_fn() {
        getActivityInfo({
          activityId: this.activityId,
          userId: getUserId(),
        })
          .then(res => {
            if (res.data.code === 1) {
              // 1为已领取  0 未领取
              this.activity = res.data.data.goods[0]?(res.data.data.goods[0].exchange === 1):0;
              this.goodsId = res.data.data.goods[0]?(res.data.data.goods[0].id):null;
              this.watchCredit = res.data.data.activity.watchCredit - res.data.data.user.credit; //  获取要观看的分钟
              this.name = res.data.data.user.realName;
              if (this.activity) {
                // 请求兑换的证书信息
                this.isShowBtn = true;
              } else {
                // 刚进入页面判断时间是否符合
                if (this.ocs_muke_time >= this.watchCredit && this.lock_once) {
                  this.showAlert_fn();
                }
              }
            }
          })
      },
      // 获取播放时间
      playerTime_get(player) {
        // 点击播放按钮事件
        if (!this.activity) {
          player.on('play', () => {
            // 只有第一次点击播放的时候才加一
            // if (this.lock_once) {
            //   this.lock_once = false;

            // }
            localStorage.setItem('ocs_muke' + getUserId(true), ++this.ocs_muke_time);
            clearInterval(this.playerInterval)
            this.playerInterval = setInterval(() => {
              ++this.playerTime;
            }, 1000)
            if ((this.ocs_muke_time >= this.watchCredit) && this.lock_once) {
              this.showAlert_fn();
              // 退出全屏
              // this.player_cpu.fullscreenService.cancelFullScreen();

            }
          })
          // 播放器暂停
          player.on('pause', () => {
            clearInterval(this.playerInterval)
          })
        }
      },
      //
      countDown_get() {
        if (!this.activity) {
          // 每60秒状态加一
          if (this.playerTime % 60 === 0) {
            localStorage.setItem('ocs_muke' + getUserId(true), ++this.ocs_muke_time);
            if (this.ocs_muke_time >= this.watchCredit && this.lock_once) {
              this.showAlert_fn();
              // 退出全屏
              // this.player_cpu.fullscreenService.cancelFullScreen();
            }
          }
        }
      }
    },
    mounted() {
      if (this.videoid === this.customizationId) {
        if(getUserId(true)){
          this.ocs_muke_time = localStorage.getItem('ocs_muke' + getUserId(true)) ? localStorage.getItem('ocs_muke' + getUserId(true)) : 0;
          this.getActivityInfo_fn();
        }
      }
    },
    watch: {
      player_cpu: {
        handler(n) {
          if (this.videoid === this.customizationId) {
            this.playerTime_get(n);
          }
        }
      },
      playerTime: {
        handler(n) {
          this.countDown_get(n);
        }
      }
    },
    onUnmounted() {
      clearInterval(this.playerInterval);
    },
  }
</script>

<style scoped lang="scss">
  .btns {
    position: fixed;
    right: 2vw;
    top: 450px;
    width: 68px;
    height: 68px;
    z-index: 1;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .certificateBox {
    .mask {
      position: fixed;
      z-index: 2;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.35);
    }

    .alertBox {
      position: fixed;
      z-index: 2;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);

      .alertBg {
        width: 385px;
      }

      .alertCon {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;


        .msg1 {
          color: #C28442;
          margin-top: 43.75px;
          text-align: center;
        }

        .msg2 {
          color: #B57132;
          text-align: center;
          margin-top: 26px;
          font-size: 18px;
        }

        input {
          width: 236.25px;
          height: 52px;
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.75);
          margin: 38px auto 0;
          display: block;
          text-align: center;
          padding: 0 10px;
          font-size: 16px;

          &::-webkit-input-placeholder {
            color: #D6A46E;
          }
        }

        .btn {
          width: 236.25px;
          margin: 24px auto 0;
          display: block;
        }

        .msg3 {
          color: #C28442;
          margin-top: 15px;
          text-align: center;
          padding: 0 112px;
        }
      }

      .close {
        position: absolute;
        left: 0;
        right: 0;
        bottom: -70px;
        margin: auto;
        width: 42px;
        height: 42px;
      }
    }
  }
</style>
